import React, { useEffect, useState } from "react";
import TourRegistrationForm from "../../components/sanawar/TourRegistrationForm";
import axios from "axios";
import TourRegistrationFormClosed from "../../components/sanawar/TourRegistrationFormClosed";

const Tds = () => {
  const [isSanwarActive, setIsSanwarActive] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchForms = async () => {
      try {
        const res = await axios.get(
          `${process.env.REACT_APP_API_BASE_URL}forms`
        );
        const forms = res.data;

        const sanwarRace = forms.find(
          (item) => item.formName.toLowerCase() === "sanwar race"
        );

        if (sanwarRace && sanwarRace.Active === "true") {
          setIsSanwarActive(true);
        } else {
          setIsSanwarActive(false);
        }
      } catch (error) {
        console.error("Error fetching forms:", error);
        setIsSanwarActive(false);
      } finally {
        setLoading(false);
      }
    };

    fetchForms();
  }, []);

  if (loading) {
    return (
      <div className="flex items-center justify-center h-screen text-gray-600">
        Loading Sanawar data...
      </div>
    );
  }
  return (
    <div>
      {isSanwarActive ? (
        <TourRegistrationForm />
      ) : (
        <TourRegistrationFormClosed />
      )}
      ;
    </div>
  );
};

export default Tds;
